import styled from "styled-components";

export const LinearProgressContainer = styled.div`
  position: relative;
  top: 100px;
  width: 500px;
`;
